import { Component } from "react";
import { Link } from 'react-router-dom';
import './modal.css';
import './carousel/embla.css';
import PaintingCarousel from "./Carousel";
import Stuff from "./Stuff";
//const SLIDES = PAINTINGS;
class Home extends Component {

    constructor(props) {
        super(props)
        this.state = {
            pristine:false,
            left:null,
            right:null,
            style:{
                backgroundColor:'orange'
            },
            visible:false
        }
    }
    componentDidMount(){
      this.setState({left:true})
      const value = localStorage.getItem('userPreference');
        if (value !== null && value !== '') {
            if(value === 'true') {
                if (
                    window.appCookieManager &&
                    typeof window.appCookieManager.manage === 'function'
                  ) {
                    window.appCookieManager.manage();
                  }                  
            }
        } else {
            setTimeout(()=>{    this.setModalOn() },1500) 
        }

    }
    addCurrent() {
        this.setState({left:true})
    }
    removeCurrent() {
        this.setState({left:false})
    }

  setModalOn() {
      // 640/480
        this.setState({visible:true});
    }

    setModalOff() {
        this.setState({visible:false});
    }
    accept() {
         localStorage.setItem('userPreference', 'true');
         this.setModalOff();       
    }
    reject() {
        localStorage.setItem('userPreference', 'false');
        this.setModalOff();
    }

  render() {
        return(
            <div className="home-container" style={{ display: 'flex'}}>
            <PaintingCarousel></PaintingCarousel>
       </div>              
        )
    }
}

export default Home